<template >
    <div class="frame">
      <div class="title" :class="{ type_same_line: typeSameLine }">
        <div class="left_area" v-if="!noLeftAreaBefore">
          {{ title }}
        </div>
        <div class="no_left_area" v-else>
          {{ title }}
        </div>
        <div class="right_area">
          <slot name="headerSlot" />
        </div>
      </div>
      <div class="frame_content">
        <slot name="contentSlot" />
      </div>
    </div>
  </template>
  
  <script >
  export default {
    name: "frame",
    props: {
      title: {
        type: String,
        default: "标题",
      },
      color: {
        type: String,
        default: "",
      },
      typeSameLine: {
        type: Boolean,
        default: false,
      },
      noLeftAreaBefore: {
        type: Boolean,
        default: false,
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .frame {
    // padding-top: 10px;
    // padding-left: 16px;
    position: relative;
  
    .title {
      display: flex;
      height: 52px;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #f5f5f5;
      .left_area {
        position: relative;
        padding-left: 16px;
        font-weight: 700;
        // font-size: 13px;
        color: #333;
        display: flex;
        align-items: center;
  
        &::before {
          position: absolute;
          content: "";
          width: 6px;
          height: 18px;
          background: #409EFF;
          top: 50%;
          left: 0;
          transform: translateY(-50%);
          // border-radius: 50%;
        }
  
      }
      .no_left_area {
        position: relative;
        // padding-left: 16px;
        font-weight: 700;
        // font-size: 13px;
        color: #333;
        display: flex;
        align-items: center;
      }
  
  
  
      .right_area {
        padding-right: 20px;
      }
    }
  
    .frame_content {}
  
    .type_same_line {
      position: absolute;
      z-index: 2;
      top: 6px;
    }
  }</style>